import { render } from "./AiAssistantView.vue?vue&type=template&id=5fb5c3dc&scoped=true"
import script from "./AiAssistantView.vue?vue&type=script&lang=js"
export * from "./AiAssistantView.vue?vue&type=script&lang=js"

import "./AiAssistantView.vue?vue&type=style&index=0&id=5fb5c3dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb5c3dc"]])

export default __exports__